import React, { useContext } from 'react';
import Hidden from '@material-ui/core/Hidden';
import { Box } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import CmtImage from '../../../../@coremat/CmtImage';
import { useSelector } from 'react-redux';
import AppContext from '../../contextProvider/AppContextProvider/AppContext';

const Logo = ({ color, ...props }) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const { currentApplication, setCurrentApplication } = useContext(AppContext);
  var logoUrl = '';
  var logoSymbolUrl = '';
  var hostName = window.location.hostname;
  var brandId = authUser.brandId;
  var x = '155px';

  if (authUser != null) {
    if (authUser.clouduser == 0) {
      logoUrl = color === 'white' ? '/images/webbookingpro_logo_white.png' : '/images/webbookingpro_logo.png';
      logoSymbolUrl = color === 'white' ? '/images/wbpsymbol.png' : '/images/wbpsymbol.png';
      if (brandId == 0) {
        document.title = 'WebBookingPro';
      }
      if (brandId == 1) {
        logoUrl = 'https://app.webbookingpro.com/images/lunalink_logo_header.png';
        if (currentApplication == 2) logoUrl = 'https://app.webbookingpro.com/images/sophiasurge_logo_header.png';
        if (currentApplication == 1) logoUrl = 'https://app.webbookingpro.com/images/zoezoom_logo_header.png';
        logoSymbolUrl = logoUrl;
        window.title = 'forotel';
        x = '75px';
        // window.title = color;
      }
    } else {
      window.title = 'Milenij by WebBookingPro';
      logoUrl = color === 'white' ? '/images/logo-milenij-white.png' : '/images/logo-milenij.png';
      logoSymbolUrl = color === 'white' ? '/images/logo-milenij-white-symbol.png' : '/images/logo-milenij-symbol.png';
    }
  }
  return (
    <Box className="pointer" {...props}>
      <Hidden xsDown>
        <NavLink to="/">
          <CmtImage src={logoUrl} alt="logo" style={{ maxHeight: 35 }} />
        </NavLink>
      </Hidden>
      <Hidden smUp>
        <NavLink to="/">
          <CmtImage src={logoSymbolUrl} alt="logo" style={{ maxHeight: 35 }} />
        </NavLink>
      </Hidden>
    </Box>
  );
};

export default Logo;
